import { Component, OnInit, ViewChild, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-bitacora-grupo',
  templateUrl: './bitacora-grupo.component.html',
  styleUrls: ['./bitacora-grupo.component.scss']
})
export class BitacoraGrupoComponent implements OnInit, OnDestroy, AfterViewInit {

  //  Variables DataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    private _cartera: CarteraService
  ) 
  { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.dtOptions = {
      scrollY: '383px',
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      order: [0, 'desc'],
      columns: [
        {
          title: 'Fecha',
          data: 'fyhsis'
        },
        {
          title: 'Actividad Realizada',
          data: 'Actividad'
        },
        {
          title: 'Estado Ant.',
          data: 'estado_anterior'
        },
        {
          title: 'Nvo. Estado',
          data: 'estado_nuevo'
        },
        {
          title: 'Usuario',
          data: 'usuario_nombre'
        },
        {
          title: 'Documento',
          data: 'documento_benef',
        },
        {
          title: 'Beneficiario',
          data: 'benef_nombre'
        },{
          title: 'Contrato Ant.',
          data: 'radicado_ant'
        },
        {
          title: 'NIT.',
          data: 'doc_titular_ant'
        },
        {
          title: 'Titular Ant.',
          data: 'nom_titulat_ant'
        },
        {
          title: 'NIT.',
          data: 'doc_titular_nvo'
        },
        {
          title:'Nvo. Titular',
          data: 'nom_titular_nvo'
        }
      ],
      responsive: true
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerBitacoraGrupo(this._data.base_datos, this._data.search_code).subscribe((data: any) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  public renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
